import React, { forwardRef, useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { Stripe } from '@stripe/stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'

import StripePaymentForm, {
  StripePaymentFormHandle,
  StripePaymentFromProps,
} from './StripePaymentForm'

export interface StripePaymentFormComponentProps
  extends StripePaymentFromProps {
  readonly publicKey?: string
  readonly stripeAccount?: string
}
const StripePaymentFormComponent = forwardRef(
  function StripePaymentFormComponent(
    { publicKey, stripeAccount, ...rest }: StripePaymentFormComponentProps,
    ref: React.ForwardedRef<StripePaymentFormHandle>,
  ) {
    const [stripePromise, setStripePromise] = useState<Promise<Stripe | null>>()

    useEffect(() => {
      if (publicKey) {
        setStripePromise(
          loadStripe(publicKey, {
            stripeAccount,
          }),
        )
      }
    }, [publicKey, stripeAccount])

    if (!stripePromise) {
      return null
    }

    return (
      // @ts-ignore
      <Elements stripe={stripePromise}>
        <StripePaymentForm ref={ref} {...rest} />
      </Elements>
    )
  },
)

export default StripePaymentFormComponent
